import { defaultSurveyButtonConfig } from "./survey.constants";

export function nextIdentifier(prefix, records) {
  const used = new Set((records || []).map((record) => String(record.id)));
  let number = 1;
  let candidate = "";
  do {
    candidate = `${prefix}_${String(number).padStart(3, "0")}`;
    number += 1;
  } while (used.has(candidate));
  return candidate;
}

export function newOption(options) {
  return {
    id: nextIdentifier("option", options),
    label: "",
    order: (options || []).length + 1,
  };
}

export function newQuestion(type, questions) {
  const question = {
    id: nextIdentifier("question", questions),
    type,
    question: "",
    description: "",
    required: true,
    order: (questions || []).length + 1,
  };
  if (type === "single_choice" || type === "multi_choice") {
    return {
      ...question,
      options: [newOption([])],
      allowOther: false,
      otherLabel: "Other",
      otherPlaceholder: "",
    };
  }
  if (type === "text") {
    return { ...question, inputStyle: "multi_line", placeholder: "" };
  }
  if (type === "number") {
    return {
      ...question,
      placeholder: "",
      unit: "",
      validation: { min: "", max: "", step: 1 },
    };
  }
  if (type === "rating") {
    return {
      ...question,
      ratingStyle: "stars",
      min: 1,
      max: 5,
      minLabel: "",
      maxLabel: "",
    };
  }
  return question;
}

export function newSurveyForm() {
  return {
    id: null,
    title: "",
    description: "",
    status: "draft",
    targetingType: 1,
    testLeadCount: 0,
    reward: null,
    buttonConfig: { ...defaultSurveyButtonConfig },
    questions: [newQuestion("single_choice", [])],
  };
}
